import { faFileAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { getSalesOrders } from "../../actions/orderAction";
import BreadCrumb from "../../components/Breadcrumb";
import Loader from "../../components/Loader";
import { formatDate, getUserDetail } from "../../utils/helper";

const SalesOrder = () => {
  const orderHistoryList = useSelector((state) => state.order.salesOrderList);

  const [showPopup, setShowPopup] = useState(false);
  const [activeID, setActiveId] = useState(0);
  const [activeInvoice, setActiveInvoice] = useState(null);
  const dispatch = useDispatch();
  const [showInvoice, setShowInvoice] = useState(false);
  const [items, setItems] = useState([]);
  const [hasDiscount, setHasDiscount] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    dispatch(
      getSalesOrders(getUserDetail()?.customerId, () => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  const setActive = (id, detail) => {
    setActiveId(id);
    setActiveInvoice(detail);
    setShowInvoice(true);
  };

  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = items.filter(
      (x) =>
        x.patients.some((y) =>
          y.patientName.toLowerCase().includes(searchTerm.toLowerCase())
        ) ||
        x.subscriptions.some((y) =>
          y.subscriptionName.toLowerCase().includes(searchTerm.toLowerCase())
        ) ||
        x.products.some((y) =>
          y.productName.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );
    setFilteredList(newList);
  };

  useEffect(() => {
    if (orderHistoryList?.length > 0) {
      setItems(orderHistoryList);
      setFilteredList(orderHistoryList);
    }
  }, [orderHistoryList]);

  const columns = [
    {
      dataField: "OrderType",
      text: "Order Type",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.OrderType.value}</p>
          </>
        );
      },
    },
    {
      dataField: "OrderNbr",
      text: "Order Number",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.OrderNbr.value}</p>
          </>
        );
      },
    },
    {
      dataField: "Status",
      text: "Status",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.Status.value}</p>
          </>
        );
      },
    },
    {
      dataField: "CreatedDate",
      text: "Created On",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{formatDate(row.CreatedDate.value)}</p>
          </>
        );
      },
    },
    {
      dataField: "OrderedQty",
      text: "Ordered Quantity",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.OrderedQty.value}</p>
          </>
        );
      },
    },
    {
      dataField: "OrderTotal",
      text: "Total Cost",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>${row.OrderTotal.value}</p>
          </>
        );
      },
    },
  ];

  return (
    <div className="patients-page">
      {isLoading && <Loader />}
      <BreadCrumb pageName="Orders" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Sales Orders</h3>
          <p className="page-desc">Below is a list of your orders.</p>
        </div>
      </div>

      <div className="row mt">
        <div className="col-md-12">
          {items.length > 0 ? (
            <>
              <BootstrapTable
                classes="react-bootstrap-table"
                columns={columns}
                keyField="id"
                data={filteredList}
                headerClasses="header-class"
              />
            </>
          ) : (
            <p className="page-desc">There are no orders at this time</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default SalesOrder;
